import { UseBreadcrumbsDataParams } from './Breadcrumbs.types'
import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'

// Export for use in route loaders
export const fetchBreadcrumbsLabels = async (
  keys: UseBreadcrumbsDataParams
) => {
  const allKeys = Object.keys(keys)
  if (allKeys.length > 0) {
    const planId = keys.plan_id ? `plan_id=${keys.plan_id}` : ''
    const workcentreId = keys.workcentre_id
      ? `&workcentre_id=${keys.workcentre_id}`
      : ''
    const queryString = `${planId}${workcentreId}`
    const { data } = await request({
      url: `/app-labels?${queryString}`,
    })
    return data
  }
  return {
    data: { data: {} },
  }
}

export const useBreadcrumbsData = (keys: UseBreadcrumbsDataParams) => {
  return useQuery(
    ['breadcrumbs', keys.plan_id, keys.workcentre_id],
    () => fetchBreadcrumbsLabels(keys),
    {
      select: (data) => data.data,
      refetchOnWindowFocus: false,
      cacheTime: 3600 * 48,
    }
  )
}
